import { Tooltip } from '@mui/material';
import i18n from '../../../libs/language';
import ProfileAssistantIcon from '@old/assets/svg/main-menu/ai-profile-assistant-icon.svg';

export function AIProfileAssistantIconComponent() {
  return (
    <Tooltip title={i18n.t('app.coming_soon')} arrow>
      <span
        style={{
          display: 'inline-block',
          cursor: 'not-allowed',
          lineHeight: 0,
        }}
      >
        <img src={ProfileAssistantIcon} alt="assistant" width={60} height={60} />
      </span>
    </Tooltip>
  );
}
